import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.List.IRequest;
type Response = Api.Core.Contract.List.IResponse;
type Headers = Api.Core.Contract.List.IHeaders;
const url = '/api/Sales/Contract';
export default async function contractListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
